import { Line } from '@react-three/drei';
import { useMemo } from 'react';
import { getOrigin } from '../config/siteConfig';
import { mineToScene } from '../Utils/sectionMath';
import { useStringLayerStore } from '../store/stringLayerStore';

function toScene(points, origin) {
  return (points || [])
    .map((p) => mineToScene(p.east, p.north, p.rl, origin))
    .filter(Boolean)
    .map((v) => [v.x, v.y, v.z]);
}

export default function StringLines() {
  const strings = useStringLayerStore((s) => s.strings);
  const draft = useStringLayerStore((s) => s.draft);
  const visible = useStringLayerStore((s) => s.visible);
  const origin = getOrigin();
  const rows = useMemo(() => {
    if (!visible) return [];
    return strings
      .map((s) => {
        const pts = toScene(s.points, origin);
        if (s.closed && pts.length >= 2) pts.push(pts[0]);
        return { id: s.id, pts };
      })
      .filter((s) => s.pts.length >= 2);
  }, [strings, visible, origin]);
  const draftPts = useMemo(() => toScene(draft, origin), [draft, origin]);

  return (
    <group userData={{ mdvLayerKey: 'mdv-strings', mdvSkipClip: false }}>
      {rows.map((row) => (
        <Line key={row.id} points={row.pts} color="#38bdf8" lineWidth={2} />
      ))}
      {draftPts.length >= 2 ? <Line points={draftPts} color="#facc15" lineWidth={2} dashed dashSize={4} gapSize={2} /> : null}
      {draftPts.length === 1 ? (
        <mesh position={draftPts[0]}>
          <sphereGeometry args={[1.6, 8, 8]} />
          <meshBasicMaterial color="#facc15" />
        </mesh>
      ) : null}
    </group>
  );
}
